import React from 'react'; // eslint-disable-line no-unused-vars

import S from 'constants/string.const';

import CN from './Space.module.scss';

const Space = ({ children, bold }) => {
  const content = bold ? <span className={CN.bold}>{children}</span> : children;

  return (
    <>
      {S.space}
      {content}
      {S.space}
    </>
  );
};

export default Space;
